// Navigation helpers for the compact date picker (docs/design/COMPACT_DATE_PICKER.md).
// Dates are local calendar dates; months are handled as the 1st of the month.

export const monthStart = (date) => new Date(date.getFullYear(), date.getMonth(), 1);

export const addMonths = (date, count) => new Date(date.getFullYear(), date.getMonth() + count, 1);

const monthIndex = (date) => date.getFullYear() * 12 + date.getMonth();

// First and last navigable month (1st of the month), or null when open.
export const navBounds = ({ fromYear, toYear, minDate, maxDate } = {}) => {
  const firsts = [
    fromYear != null ? new Date(fromYear, 0, 1) : null,
    minDate ? monthStart(minDate) : null,
  ].filter(Boolean);
  const lasts = [
    toYear != null ? new Date(toYear, 11, 1) : null,
    maxDate ? monthStart(maxDate) : null,
  ].filter(Boolean);
  return {
    first: firsts.length ? firsts.reduce((a, b) => (monthIndex(a) >= monthIndex(b) ? a : b)) : null,
    last: lasts.length ? lasts.reduce((a, b) => (monthIndex(a) <= monthIndex(b) ? a : b)) : null,
  };
};

export const monthAllowed = (year, month, { first, last } = {}) => {
  const index = year * 12 + month;
  return (!first || index >= monthIndex(first)) && (!last || index <= monthIndex(last));
};

export const yearAllowed = (year, { first, last } = {}) =>
  (!first || year >= first.getFullYear()) && (!last || year <= last.getFullYear());

export const clampMonth = (date, bounds = {}) => {
  const month = monthStart(date);
  if (bounds.first && monthIndex(month) < monthIndex(bounds.first)) return bounds.first;
  if (bounds.last && monthIndex(month) > monthIndex(bounds.last)) return bounds.last;
  return month;
};

// Twelve years (a 3 x 4 grid) with the focus year in the second row.
export const yearPage = (focusYear) => Array.from({ length: 12 }, (_, i) => focusYear - 4 + i);
